import React from "react";
import "./Review.css";
import Footer from "../Common/Footer";
import ProfileSidebar from "../profileSidebar/ProfileSidebar";
import Header from "../Common/Header/Header";
import Swal from "sweetalert2";
import Axios from "axios";

const Review = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();

    const reviewData = {
      email: e.target.email.value,
      star: e.target.star.value,
      review: e.target.review.value,
    };
    const token = localStorage.getItem("token");
    try {
      await Axios.post("https://lawacademyadmin.icicle.dev/api/review", reviewData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        console.log(res);
        if (res.status === 200) {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Review submitted successfully.",
            confirmButtonText: "Ok",
            confirmButtonColor: "#006837",
          });
          // e.target.reset();
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Review failed.",
            confirmButtonText: "Ok",
            confirmButtonColor: "red",
          });
        }
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        confirmButtonText: "Ok",
        confirmButtonColor: "red",
      });
      // console.log(error);
    }
  };
  return (
    <div>
      <Header />
      <div className="container rounded bg-white mt-5 mb-5" style={{ paddingTop: "150px" }}>
        <div className="row">
          <ProfileSidebar />
          <div className="col-md-8 border-right">
            {" "}
            <script src="https://use.fontawesome.com/a6f0361695.js"></script>
            <h2 id="fh2">WE APPRECIATE YOUR REVIEW!</h2>
            <h6 id="fh6">
              Your review will help us to improve our Teaching Capablity, and customer services.
            </h6>
            <form id="feedback" onSubmit={handleSubmit}>
              <div className="pinfo">Please give your review here</div>

              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-envelope"></i>
                </span>
                <input
                  name="email"
                  type="email"
                  className="form-control"
                  placeholder="Your Email Address"
                />
              </div>

              <div className="pinfo">Rate our overall services.</div>

              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-heart"></i>
                </span>
                <select required name="star" className="form-control" id="rate">
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>

              <div className="pinfo">Write your feedback.</div>

              <div className="input-group">
                <span className="input-group-addon">
                  <i className="fa fa-pencil"></i>
                </span>
                <textarea className="form-control" id="review" rows="5"></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Review;
